import { createContext, useContext, type CSSProperties } from 'react';
import { hexHighlight, playerColor, type SeatHue } from '@tv-casino/viewmodels/lib/playerColors.js';

/** The pure colour math lives in `@tv-casino/viewmodels`; what stays here is
 * the React context and the CSS-variable styling a DOM chip reads — the parts
 * a native renderer replaces with its own. */
export * from '@tv-casino/viewmodels/lib/playerColors.js';

/**
 * The live table's seat colours for anything drawing chips. Defaults to the
 * by-index map, so a felt rendered outside a table (the landing demo) still
 * paints.
 */
export const SeatHuesContext = createContext<SeatHue>(playerColor);

export const useSeatHue = (): SeatHue => useContext(SeatHuesContext);

/** The custom properties a player chip reads its face from. */
export const chipStyle = (hex: string): CSSProperties =>
  ({ '--player-c': hex, '--player-c-light': hexHighlight(hex) }) as CSSProperties;
